// import React, { useContext, useEffect, useState } from "react";
// import {
//   Bar,
//   Line,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   ResponsiveContainer,
//   ComposedChart,
//   LabelList,
//   Legend
// } from "recharts";
// import { PrAnalysisApi } from "../../../../../../api/Api";
// import { FaCrosshairs } from 'react-icons/fa';
// import { jsPDF } from "jspdf";
// import "jspdf-autotable"; // Ensure you import the autoTable plugin
// import * as XLSX from "xlsx";
// import logo from '../../../../../../assets/img/logos/logo 2.png';
// import IconButton from '@mui/material/IconButton';
// import RefreshIcon from '@mui/icons-material/Refresh';

// import {
//   Box,
//   Card,
//   CardContent,
//   Grid,
//   Typography,
//   useTheme,
//   CardActions,
//   Button
// } from "@mui/material";
// import { AuthenticationContext } from "../../../../../../context/AuthenticationContext";
// import ExportExcel from "../../../../../../components/exportExcel/ExportExcel1";
// import { PASS_KEY, WEB_KEY, BaseUrl } from '../../../../../../api/AxiosApi'
// import ExportPdf from "../../../../../../components/exportPdf/ExportPdf";


// // Function to get default dates
// export function getDateTimeForDashboardTab1(date = new Date()) {
//   const formattedCurrentDate = date.toISOString().split("T")[0]; // Format: YYYY-MM-DD
//   const tenDaysAgo = new Date(date);
//   tenDaysAgo.setDate(tenDaysAgo.getDate() - 10);
//   const formattedTenDaysAgo = tenDaysAgo.toISOString().split("T")[0]; // Format: YYYY-MM-DD

//   return {
//     Today: formattedCurrentDate,
//     LastDay: formattedTenDaysAgo,
//   };
// }

// const Tab8LogContent = () => {
//   const { LoggedInUserInfo } = useContext(AuthenticationContext)
//   const [StartDate, setStartDate] = useState(getDateTimeForDashboardTab1().LastDay);
//   const [EndDate, setEndDate] = useState(getDateTimeForDashboardTab1().Today);


//   const theme = useTheme();
//   const { palette, spacing, shape: { borderRadius } } = useTheme()

//   // Pagination States
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage] = useState(10);
//   const [logData, setLogData] = useState([])
//   const [loading, setLoading] = useState(true);


//   // console.log("startdate", StartDate)
//   // console.log("enddate", EndDate)
//   const credentials = {
//     USER: localStorage.getItem("LoginID") || "",
//     LCODE: localStorage.getItem("LCODE") || "",
//     PASS_KEY: localStorage.getItem("PASS_KEY") || "XYZ",
//     WEB_KEY: localStorage.getItem("WEB_KEY") || "WEBXYZ321",
//     DT1: StartDate, // Default Start Date
//     DT2: EndDate, // Default End Date
//   };


//   // Fetch data from the API
//   const fetchLogData = async () => {
//     setLoading(false);
//     try {
//       const res = await PrAnalysisApi(credentials);


//       if (res?.data && Array.isArray(res.data)) {
//         // console.log("Fetched Data:", res.data);
//         setLogData(res.data);



//       } else {
//         // console.error("Data structure mismatch:", res);

//       }
//     } catch (err) {
//       // console.error("Error fetching data:", err);
//     }
//   };

//   // Fetch data on component mount
//   // useEffect(() => {
//   //   fetchLogData();
//   // }, [StartDate, EndDate]);

//   useEffect(() => {
//     fetchLogData();
//   }, []);

//   const ImageUrl = `${BaseUrl}CMN_02/GET_COM_LOGO?LOGIN_ID=${credentials.USER}&LOC_CODE=${credentials.LCODE}&PASS_KEY=${PASS_KEY}&WEB_KEY=${WEB_KEY}`

//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentData = logData.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(logData.length / itemsPerPage);

//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   // Define keys to exclude (you can also define keys to include instead)
//   const excludeKeys = ["NO", "KWP", "KW_MAX", "KW_MAX_DATE", "USER"]; // Replace "key1", "key2" with actual keys you don't want to export

//   // Filter logData
//   const filteredLogData = logData.map((item) => {
//     const filteredItem = {};
//     Object.keys(item).forEach((key) => {
//       if (!excludeKeys.includes(key)) {
//         filteredItem[key] = item[key]; // Include keys not in excludeKeys
//       }
//     });
//     return filteredItem;
//   });

//   // Get table headers from filteredLogData
//   const tableHeaders = filteredLogData.length > 0 ? Object.keys(filteredLogData[0]) : [];

//   // Export to Excel
//   // const exportToExcel = () => {
//   //   const ws = XLSX.utils.json_to_sheet(filteredLogData);
//   //   const wb = XLSX.utils.book_new();
//   //   XLSX.utils.book_append_sheet(wb, ws, "Plant Generation");
//   //   XLSX.writeFile(wb, `Plant Generation To ${EndDate.replace(" ", "T")} Plant Generation.xls`);
//   // };

//   const exportToExcel = async () => {
//     await ExportExcel(
//       ImageUrl,
//       logData,
//       StartDate,
//       EndDate,
//       "Plant Generation Log",
//       LoggedInUserInfo
//     );
//   };




//   // Helper to convert image URL to base64
//   const getBase64ImageFromUrl = async (url) => {
//     const response = await fetch(url);
//     const blob = await response.blob();

//     return new Promise((resolve, reject) => {
//       const reader = new FileReader();
//       reader.onloadend = () => resolve(reader.result);
//       reader.onerror = reject;
//       reader.readAsDataURL(blob);
//     });
//   };

//   const exportToPDF = async () => {
//     const doc = new jsPDF({ orientation: "landscape", format: [300, 700] });

//     const textX = 20;
//     const textY = 20;
//     const logoWidth = 40;
//     const logoHeight = 25;
//     const pdfWidth = doc.internal.pageSize.width;

//     // ==== LEFT SIDE (Plant Info) ====
//     doc.setFontSize(15);
//     doc.setFont("helvetica", "bold");
//     doc.text(
//       `Plant Name/User Name: ${LoggedInUserInfo?.username || ""}`,
//       textX,
//       textY + 10
//     );

//     doc.setFontSize(10);
//     doc.text(
//       `Plant Capacity : ${LoggedInUserInfo?.PLANT_CAPACITY || ""}`,
//       textX,
//       textY + 16
//     );
//     doc.text(
//       `Plant Address : ${LoggedInUserInfo?.Address || ""}`,
//       textX,
//       textY + 22
//     );

//     // ==== CENTER LOGO ====
//     if (logo) {
//       try {
//         const logoBase64 = await getBase64ImageFromUrl(logo);
//         const logoX = (pdfWidth - logoWidth) / 2;
//         doc.addImage(logoBase64, "PNG", logoX, textY, logoWidth, logoHeight);
//       } catch (err) {
//         // console.error("Failed to load center logo:", err);
//       }
//     }

//     // ==== RIGHT SIDE LOGO ====
//     if (ImageUrl) {
//       try {
//         const rightBase64 = await getBase64ImageFromUrl(ImageUrl);
//         const rightImgWidth = 100;
//         const rightImgHeight = 30;
//         const rightX = pdfWidth - rightImgWidth - 20;
//         doc.addImage(rightBase64, "PNG", rightX, textY, rightImgWidth, rightImgHeight);
//       } catch (err) {
//         // console.error("Failed to load right logo:", err);
//       }
//     }

//     // ==== TITLE BELOW HEADER ====
//     const title = `Plant Generation From ${StartDate.replace(" ", "T")} To ${EndDate.replace(
//       " ",
//       "T"
//     )}`;
//     doc.setFontSize(12);
//     doc.text(title, pdfWidth / 2, textY + logoHeight + 15, { align: "center" });

//     // ==== TABLE ====
//     doc.autoTable({
//       head: [tableHeaders],
//       body: currentData.map((item) =>
//         tableHeaders.map((key) => item[key] ?? "")
//       ),
//       startY: textY + logoHeight + 25,
//       theme: "grid",
//       styles: { fontSize: 8, cellPadding: 2 },
//       headStyles: { fillColor: [1, 59, 123] },
//       margin: { left: 20, right: 20 },
//       pageBreak: "auto",
//     });

//     // ==== SAVE ====
//     doc.save(
//       `Plant Generation From ${StartDate.replace(" ", "T")} To ${EndDate.replace(
//         " ",
//         "T"
//       )}.pdf`
//     );
//   };



//   // Handle Start Date change
//   const handleStartDateChange = (value) => {
//     setStartDate(value); // Update the StartDate directly
//   };

//   // Handle End Date change
//   const handleEndDateChange = (value) => {
//     setEndDate(value); // Update the EndDate directly
//   };



//   //   const exportToPDF = async () => {
//   //     await ExportPdf(
//   //         ImageUrl,
//   //         currentData,
//   //         StartDate,
//   //         EndDate,
//   //         "Plant Generation Log",
//   //         LoggedInUserInfo,
//   //         logo,
//   //         tableHeaders

//   //     );
//   // };


//   // Refresh data only when clicking "Show"
//   function onRefreshData() {
//     if (StartDate.length !== 0 && EndDate.length !== 0) {
//       fetchLogData(); // Fetch data only after clicking the button
//     } else {
//       alert("Please provide valid dates");
//     }
//   }

//   return (
//     <Box bgcolor={"background.default"} py={2}>

//       <Grid container spacing={spacing(1)} flexGrow={1} sx={{ mt: .3 }}>
//         <Grid key="chart-grid" item xs={12}>
//           <Card>
//             <CardActions sx={{
//               display: "flex", // Enable flexbox
//               justifyContent: "flex-end", // Align items to the right
//               alignItems: "center", // Center items vertically
//               gap: "16px", // Add some spacing between the inputs
//             }}>
//               <label>

//                 <input
//                   type="date"
//                   value={StartDate} // Use StartDate directly
//                   onChange={(e) => handleStartDateChange(e.target.value)}
//                   style={{
//                     padding: "2px 2px",
//                     borderRadius: "14px",
//                     border: "1px solid #ccc",
//                   }}
//                 />
//               </label>
//               <label>
//                 To
//                 <input
//                   type="date"
//                   value={EndDate} // Use EndDate directly
//                   onChange={(e) => handleEndDateChange(e.target.value)}
//                   style={{
//                     padding: "2px 2px",
//                     borderRadius: "14px",
//                     border: "1px solid #ccc",
//                   }}
//                 />
//               </label>
//               {/* <Button onClick={onRefreshData} variant='contained' sx={{ color: 'white', p: 0, m: 0, fontSize: '12px', backgroundColor: palette.tintBlue, borderRadius: borderRadius }}>Show</Button> */}
//               <IconButton
//                 onClick={onRefreshData}
//                 sx={{
//                   color: 'black',
//                   // backgroundColor: palette.tintBlue,
//                   borderRadius: borderRadius,
//                   p: 1, // Adjust padding if needed
//                 }}
//               >
//                 <RefreshIcon sx={{ fontSize: '24px' }} />
//               </IconButton>
//             </CardActions>
//           </Card>
//         </Grid>


//       </Grid>


//       <div style={{ padding: "4px", marginTop: ".4rem" }}>
//         {/* Controls */}
//         <div className="row">
//           <div className="col-md-12">
//             <div style={containerStyle} className="head">
//               <p style={responsiveHeaderStyle}>PR Analysis</p>
//               <div style={responsiveControlsStyle}>

//                 <button onClick={fetchLogData} style={buttonStyle}>
//                   Show
//                 </button>
//                 <button onClick={exportToExcel} style={exportButtonStyle}>
//                   Excel
//                 </button>
//                 <button onClick={exportToPDF} style={exportButtonStyle2}>
//                   PDF
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//         {/* Table */}
//         <div className="table-responsive">
//           <table className="table table-hover table-bordered">
//             <thead className="text-center" style={{ backgroundColor: "rgb(253, 248, 228)" }}>
//               <tr>
//                 <th style={tableHeading}> Date </th>
//                 <th style={tableHeading}>Energy[kWh]</th>
//                 <th style={tableHeading}> CUF </th>
//                 <th style={tableHeading}> PR </th>
//                 <th style={tableHeading}> Capacity[kW]</th>
//                 <th style={tableHeading}>Specific Yield</th>
//                 <th style={tableHeading}> Solar Insolation[kWh/m²/day]</th>
//                 <th style={tableHeading}>Expected Generation[kWh]</th>
//                 <th style={tableHeading}>Peak Radiation[W/m²] </th>
//                 <th style={tableHeading}>Peak Radiation Time </th>


//               </tr>
//             </thead>
//             <tbody>
//               {loading ? (
//                 <tr>
//                   <td colSpan={tableHeaders.length} className="text-center">
//                     Loading...
//                   </td>
//                 </tr>
//               ) : currentData.length > 0 ? (
//                 currentData.map((item, rowIndex) => (
//                   <tr key={rowIndex}>

//                     <td className="text-center align-middle" style={tableBody}>
//                       {item.DATET || ""}
//                     </td>

//                     <td className="text-center align-middle" style={tableBody}>
//                       {item.ENG || ""}
//                     </td>

//                     <td className="text-center align-middle" style={tableBody}>
//                       {item.CUF || ""}
//                     </td>
//                     <td className="text-center align-middle" style={tableBody}>
//                       {item.PR || ""}
//                     </td>
//                     <td className="text-center align-middle" style={tableBody}>
//                       {item.CAP || ""}
//                     </td>
//                     <td className="text-center align-middle" style={tableBody}>
//                       {item.Specific_Yield || ""}
//                     </td>
//                     <td className="text-center align-middle" style={tableBody}>
//                       {item.Solar_Insolation || ""}
//                     </td>

//                     <td className="text-center align-middle" style={tableBody}>
//                       {item.Expected_Generation || ""}
//                     </td>

//                     <td className="text-center align-middle" style={tableBody}>
//                       {item.PEAK_RADIATION || ""}
//                     </td>

//                     <td className="text-center align-middle" style={tableBody}>
//                       {item.PEAK_RADIATION_DATE || ""}
//                     </td>

//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan={tableHeaders.length} className="text-center">
//                     No data available
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>

//         {/* Pagination */}
//         {/* <div style={{ textAlign: "right", marginTop: "10px" }}>
//           <button
//             onClick={() => handlePageChange(currentPage - 1)}
//             disabled={currentPage === 1}
//             style={paginationButtonStyle}
//           >
//             Previous
//           </button>
//           {[...Array(totalPages)].map((_, index) => (
//             <button
//               key={index}
//               onClick={() => handlePageChange(index + 1)}
//               style={{
//                 ...paginationButtonStyle,
//                 backgroundColor: currentPage === index + 1 ? "black" : "black",
//                 color: currentPage === index + 1 ? "#fff" : "#fff",
//               }}
//             >
//               {index + 1}
//             </button>
//           ))}
//           <button
//             onClick={() => handlePageChange(currentPage + 1)}
//             disabled={currentPage === totalPages}
//             style={paginationButtonStyle}
//           >
//             Next
//           </button>
//         </div> */}

//         <div style={{ textAlign: "right", marginTop: "10px" }}>
//           <button
//             onClick={() => handlePageChange(currentPage - 1)}
//             disabled={currentPage === 1}
//             style={paginationButtonStyle}
//           >
//             Previous
//           </button>

//           {[...Array(totalPages)].map((_, index) => {
//             const isActive = currentPage === index + 1;
//             return (
//               <button
//                 key={index}
//                 onClick={() => handlePageChange(index + 1)}
//                 style={{
//                   ...paginationButtonStyle,
//                   backgroundColor: isActive ? "#000" : "white",
//                   color: isActive ? "#fff" : "#356E35",
//                 }}
//               >
//                 {index + 1}
//               </button>
//             );
//           })}

//           <button
//             onClick={() => handlePageChange(currentPage + 1)}
//             disabled={currentPage === totalPages}
//             style={paginationButtonStyle}
//           >
//             Next
//           </button>
//         </div>


//       </div>

//     </Box>
//   );
// };

// export default Tab8LogContent;



// /* Styles */

// const containerStyle = {
//   display: "flex",
//   justifyContent: "space-between",
//   alignItems: "center",
//   flexWrap: "wrap",
//   marginBottom: "7px",
//   border: "1px solid lightgray",
//   padding: "3px",
//   borderRadius: "7px"
// };

// const responsiveHeaderStyle = {
//   fontWeight: "bold",
//   margin: "0",
//   display: "flex",
//   flexWrap: "wrap"
// };

// const responsiveControlsStyle = {
//   display: "flex",
//   flexWrap: "wrap",
//   gap: "10px",
//   justifyContent: "center",
// };

// const inputStyle = {
//   padding: "2px 2px",
//   borderRadius: "14px",
//   border: "1px solid #ccc",
//   // marginLeft: "5px",
//   // fontSize: "10px",
// };

// const buttonStyle = {
//   backgroundColor: "#007BFF",
//   color: "#fff",
//   border: "none",
//   borderRadius: "14px",
//   padding: "2px 9px",
//   cursor: "pointer",
//   fontSize: "10px",
// };

// const exportButtonStyle = {
//   backgroundColor: "darkblue",
//   color: "#fff",
//   border: "none",
//   borderRadius: "14px",
//   padding: "3px 9px",
//   cursor: "pointer",
//   fontSize: "11px",
// };

// const exportButtonStyle2 = {
//   backgroundColor: "#f44336",
//   color: "#fff",
//   border: "none",
//   borderRadius: "14px",
//   padding: "3px 9px",
//   cursor: "pointer",
//   fontSize: "11px",
// };



// const paginationButtonStyle = {
//   backgroundColor: "white",
//   color: "#356E35",
//   border: "1px solid #ddd",
//   padding: "5px 10px",
//   borderRadius: "5px",
//   margin: "0 5px",
//   cursor: "pointer",
//   fontSize: "14px",
// };


// const tableHeading = {
//   color: "rgb(53, 110, 53)",
//   padding: "12px 10px",
//   fontSize: "14px",
//   whiteSpace: "nowrap",
// }

// const tableBody = {
//   padding: "5px",
//   whiteSpace: "nowrap",
// }


import React, { useContext, useEffect, useState } from "react";
import {
  Bar,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  ComposedChart,
  LabelList,
  Legend
} from "recharts";
import { PrAnalysisApi } from "../../../../../../api/Api";
import { FaCrosshairs } from 'react-icons/fa';
import { jsPDF } from "jspdf";
import "jspdf-autotable"; // Ensure you import the autoTable plugin
import * as XLSX from "xlsx";
import logo from '../../../../../../assets/img/logos/logo 2.png';
import IconButton from '@mui/material/IconButton';
import RefreshIcon from '@mui/icons-material/Refresh';

import {
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  useTheme,
  CardActions,
  Button
} from "@mui/material";
import { AuthenticationContext } from "../../../../../../context/AuthenticationContext";
import ExportExcel from "../../../../../../components/exportExcel/ExportExcel1";
import { PASS_KEY, WEB_KEY, BaseUrl } from '../../../../../../api/AxiosApi'
import ExportPdf from "../../../../../../components/exportPdf/ExportPdf";


// Function to get default dates
export function getDateTimeForDashboardTab1(date = new Date()) {
  const formattedCurrentDate = date.toISOString().split("T")[0]; // Format: YYYY-MM-DD
  const tenDaysAgo = new Date(date);
  tenDaysAgo.setDate(tenDaysAgo.getDate() - 10);
  const formattedTenDaysAgo = tenDaysAgo.toISOString().split("T")[0]; // Format: YYYY-MM-DD

  return {
    Today: formattedCurrentDate,
    LastDay: formattedTenDaysAgo,
  };
}

export default function Tab8LogContent() {
  const { palette, spacing } = useTheme();
  const { LoggedInUserInfo } = useContext(AuthenticationContext);

  const [logData, setLogData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(8);
  const [StartDate, setStartDate] = useState(getDateTimeForDashboardTab1().LastDay);
  const [EndDate, setEndDate] = useState(getDateTimeForDashboardTab1().Today);

  const credentials = {
    USER: localStorage.getItem("LoginID") || "",
    LCODE: localStorage.getItem("LCODE") || "",
    PASS_KEY: PASS_KEY,
    WEB_KEY: WEB_KEY,
    DT1: StartDate,
    DT2: EndDate,
  };

  // ✅ Fetch Data
  const fetchLogData = async () => {
    setLoading(true);
    setError(null);
    setLogData([]);

    try {
      const res = await PrAnalysisApi(credentials);
      if (res?.data && Array.isArray(res.data)) {
        setLogData(res.data);
      } else {
        setLogData([]);
      }
    } catch (err) {
      setError("Failed to fetch data.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLogData();
  }, [credentials.USER]);


  // Refresh data only when clicking "Show"
  function onRefreshData() {
    if (StartDate.length !== 0 && EndDate.length !== 0) {
        fetchLogData(); // Fetch data only after clicking the button
    } else {
        alert("Please provide valid dates");
    }
}


  const ImageUrl = `${BaseUrl}CMN_02/GET_COM_LOGO?LOGIN_ID=${credentials.USER}&LOC_CODE=${credentials.LCODE}&PASS_KEY=${PASS_KEY}&WEB_KEY=${WEB_KEY}`;

  // ✅ Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = logData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(logData.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // ✅ Static Headers (same approach as Tab5Inverter1)
  const tableHeaders = [
    { label: "Date", key: "DATET" },
    { label: "Energy[kWh]", key: "ENG" },
    { label: "CUF", key: "CUF" },
    { label: "PR", key: "PR" },
    { label: "Capacity[kW]", key: "CAP" },
    { label: "Specific Yield", key: "Specific_Yield" },
    { label: "Solar Insolation[kWh/m²/day]", key: "Solar_Insolation" },
    { label: "Expected Generation[kWh]", key: "Expected_Generation" },
    { label: "Peak Radiation[W/m²]", key: "PEAK_RADIATION" },
    { label: "Peak Radiation Time", key: "PEAK_RADIATION_DATE" },
  ];

  // ✅ Excel Export
  const exportToExcel = async () => {
    const exportData = logData.map((item) => {
      let row = {};
      tableHeaders.forEach((header) => {
        row[header.label] = item[header.key] ?? "";
      });
      return row;
    });

    await ExportExcel(
      ImageUrl,
      exportData,
      StartDate,
      EndDate,
      "Plant_Generation_Log",
      LoggedInUserInfo
    );
  };

  // ✅ PDF Export
  const exportToPDF = async () => {
    const exportData = logData.map((item) => {
      let row = {};
      tableHeaders.forEach((header) => {
        row[header.label] = item[header.key] ?? "";
      });
      return row;
    });

    await ExportPdf(
      ImageUrl,
      exportData,
      StartDate,
      EndDate,
      "Plant_Generation_Log",
      LoggedInUserInfo,
      logo,
      tableHeaders.map((h) => h.label)
    );
  };

  return (
    <>
      {/* <CssBaseline /> */}
      <Box bgcolor={"background.default"} py={spacing(1)}>
        <div>
          {/* Header */}
          <div
            style={{
              marginBottom: "5px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: "16px",
            }}
          >
            <div style={{ marginLeft: "7px", fontSize: "14px" }}>
              Plant Generation Log
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <label>
                From:&nbsp;
                <input
                  type="date"
                  value={StartDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  style={inputStyle}
                />
              </label>
              <label>
                To:&nbsp;
                <input
                  type="date"
                  value={EndDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  style={inputStyle}
                />
              </label>
              <button onClick={onRefreshData} className='button-style' >Show</button>

              <button onClick={exportToExcel} className="export-button">
                Excel
              </button>
              <button onClick={exportToPDF} className="export-button2">
                PDF
              </button>
            </div>
          </div>

          {/* Table */}
          <div className="table-responsive">
            <table className="table table-hover table-bordered">
              <thead className="text-center">
                <tr>
                  {tableHeaders.map((header) => (
                    <th key={header.key} style={tableHeading}>
                      {header.label}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan={tableHeaders.length} className="text-center">
                      Loading...
                    </td>
                  </tr>
                ) : currentData.length > 0 ? (
                  currentData.map((item, rowIndex) => (
                    <tr key={rowIndex}>
                      {tableHeaders.map((header) => (
                        <td
                          key={header.key}
                          className="text-center align-middle"
                        >
                          {item[header.key] ?? ""}
                        </td>
                      ))}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={tableHeaders.length} className="text-center">
                      No data available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <div style={{ textAlign: "right", marginTop: "10px" }}>
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              style={paginationButtonStyle}
            >
              Previous
            </button>

            {[...Array(totalPages)].map((_, index) => (
              <button
                key={index}
                onClick={() => handlePageChange(index + 1)}
                style={{
                  ...paginationButtonStyle,
                  backgroundColor: currentPage === index + 1 ? "#356E35" : "white",
                  color: currentPage === index + 1 ? "#fff" : "#356E35",
                }}
              >
                {index + 1}
              </button>
            ))}

            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              style={paginationButtonStyle}
            >
              Next
            </button>
          </div>
          
        </div>
      </Box>
    </>
  );
}




/* Styles */

const containerStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  flexWrap: "wrap",
  marginBottom: "7px",
  border: "1px solid lightgray",
  padding: "3px",
  borderRadius: "7px"
};

const responsiveHeaderStyle = {
  fontWeight: "bold",
  margin: "0",
  display: "flex",
  flexWrap: "wrap"
};

const responsiveControlsStyle = {
  display: "flex",
  flexWrap: "wrap",
  gap: "10px",
  justifyContent: "center",
};

const inputStyle = {
  padding: "2px 2px",
  borderRadius: "14px",
  border: "1px solid #ccc",
  // marginLeft: "5px",
  // fontSize: "10px",
};

const buttonStyle = {
  backgroundColor: "#007BFF",
  color: "#fff",
  border: "none",
  borderRadius: "14px",
  padding: "2px 9px",
  cursor: "pointer",
  fontSize: "10px",
};

const exportButtonStyle = {
  backgroundColor: "darkblue",
  color: "#fff",
  border: "none",
  borderRadius: "14px",
  padding: "3px 9px",
  cursor: "pointer",
  fontSize: "11px",
};

const exportButtonStyle2 = {
  backgroundColor: "#f44336",
  color: "#fff",
  border: "none",
  borderRadius: "14px",
  padding: "3px 9px",
  cursor: "pointer",
  fontSize: "11px",
};



const paginationButtonStyle = {
  backgroundColor: "white",
  color: "#356E35",
  border: "1px solid #ddd",
  padding: "5px 10px",
  borderRadius: "5px",
  margin: "0 5px",
  cursor: "pointer",
  fontSize: "14px",
};


const tableHeading = {
  color: "rgb(53, 110, 53)",
  padding: "12px 10px",
  fontSize: "14px",
  whiteSpace: "nowrap",
}

const tableBody = {
  padding: "5px",
  whiteSpace: "nowrap",
}